import {
    DTOCardFormField, NestedField,
} from 'app/types/form.types'

import {
    AddressMainCategory, ServiceCenterStatus, ServiceCenterType,
} from 'app/enums/label.enums'
import {
    ServiceCenterFormType,
} from '../serviceCenters.types'
import getWorkScheduleFields from '../WorkSchedule/workSchedule.fields'

const getFields = ({
    getAllowedValues,
    isProductionSite,
    isPlannedStatus,
    isLunchBreak,
    hasClientConsignmentStock,
    exists,
    disabled,
}: {
    getAllowedValues: (enumType: Record<string, string>) => Record<string, string>,
    isProductionSite: boolean,
    isPlannedStatus: boolean,
    isLunchBreak: boolean,
    hasClientConsignmentStock: boolean,
    exists: boolean,
    disabled: boolean,
}): DTOCardFormField<keyof ServiceCenterFormType>[] => {
    const operationalDaysFields = getWorkScheduleFields({
        isLunchBreak,
    })

    return [
        {
            id: 'generalInformation',
            title: 'General Information',
            className: 'generalInformation',
            fields: [{
                id: 'column1',
                fields: [
                    {
                        name: 'serviceCenterNumber',
                        componentName: 'InputSingleline',
                        disabled: true,
                        labelKey: 'ServiceCenter.serviceCenterNumber',
                    },
                    {
                        name: 'location',
                        componentName: 'LocationObjectSelector',
                        filterAddressMainCategory: AddressMainCategory.SERVICECENTER,
                        required: true,
                        labelKey: 'ServiceCenters.location',
                    },
                    {
                        name: 'serviceCenterStatus',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(ServiceCenterStatus),
                        required: true,
                        labelKey: 'ServiceCenter.serviceCenterStatus',
                    },
                    ...isPlannedStatus ? [{
                        name: 'serviceCenterPlannedStartDate',
                        componentName: 'DateSelect',
                        required: true,
                        labelKey: 'ServiceCenter.serviceCenterPlannedStartDate',
                    }] as NestedField<keyof ServiceCenterFormType>[] : [],
                    {
                        name: 'serviceCenterType',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(ServiceCenterType),
                        useDropdown: true,
                        required: true,
                        labelKey: 'ServiceCenter.serviceCenterType',
                        disabled: disabled || hasClientConsignmentStock,
                    },
                    {
                        name: 'serviceCenterDocumentation',
                        componentName: 'AttachmentsObjectSelector',
                        labelKey: 'ServiceCenter.serviceCenterDocumentation',
                    },
                ],
            }],
        },
        {
            id: 'serviceCenterMetrics',
            title: 'Service Center Metrics',
            className: 'serviceCenterMetrics',
            fields: [{
                id: 'column2',
                fields: [
                    {
                        name: 'orderSelectionDelay',
                        componentName: 'IntegerInput',
                        required: true,
                        labelKey: 'ServiceCenter.orderSelectionDelay',
                    },
                    {
                        name: 'maxTrucksPerDay',
                        componentName: 'IntegerInput',
                        required: true,
                        labelKey: 'ServiceCenter.maxTrucksPerDay',
                    },
                    {
                        name: 'processingThroughput',
                        componentName: 'IntegerInput',
                        required: true,
                        labelKey: 'ServiceCenter.processingThroughput',
                    },
                    {
                        name: 'enhancedSkyCenterScanning',
                        componentName: 'Checkbox',
                        labelKey: 'ServiceCenter.enhancedSkyCenterScanning',
                    },
                    {
                        name: 'isAvailableForDropoff',
                        componentName: 'Checkbox',
                        labelKey: 'ServiceCenter.isAvailableForDropoff',
                        disabled: disabled || hasClientConsignmentStock,
                    },
                    {
                        name: 'isAvailableForPickup',
                        componentName: 'Checkbox',
                        labelKey: 'ServiceCenter.isAvailableForPickup',
                        disabled: disabled || hasClientConsignmentStock,
                    },
                ],
            }],
        },
        ...!exists ? operationalDaysFields as DTOCardFormField<keyof ServiceCenterFormType>[] : [],
        {
            id: 'productMetrics',
            title: 'Product Metrics',
            className: 'productMetrics',
            fields: [{
                name: 'productMetrics',
                componentName: 'ProductMetrics',
                exists,
                required: true,
                labelKey: 'ServiceCenter.maxTrucksPerDay',
            }],
        },
        ...isProductionSite ? [{
            id: 'containerProductionRate',
            title: 'Container Production Rate',
            className: 'containerProductionRate',
            fields: [{
                name: 'containerProductionRate',
                componentName: 'ContainerProductionRate',
                required: true,
                exists,
                labelKey: 'ServiceCenter.containerProductionRate',
            }],
        }] as DTOCardFormField<keyof ServiceCenterFormType>[] : [],
        {
            id: 'storages',
            title: 'Storages',
            className: 'storages',
            fields: [{
                name: 'storages',
                componentName: 'StorageTable',
                labelKey: 'ServiceCenter.storages',
            }],
        },
    ]
}

export default getFields
